import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Index from '../views/Index'
import AgentHome from '../views/AgentHome'
import GroupHome from '../views/GroupHome'
import Cart from "../views/Cart"
import AgentSelectMember from "../views/AgentSelectMember";
import GroupSelectMember from "../views/GroupSelectMember";
import Plans from "../views/Plans";
import Plan from "../views/Plan";
import Enrolment from "../views/Enrollment";
import PersonalInformation from "../components/Enrollment/PersonalInformation";
import ContactInformation from "../components/Enrollment/ContactInformation";
import EmployerInformation from "../components/Enrollment/EmployerInformation";
import BeneficiaryInformation from "../components/Enrollment/BeneficiaryInformation";
import HealthQuestions from "../components/Enrollment/HealthQuestions";
import DependentInformation from "../components/Enrollment/DependentInformation";
import ReviewAndConfirm from "../components/Enrollment/ReviewAndConfirm";
import AgreementAndSignature from "../components/Enrollment/AgreementAndSignature";
import BillingInformation from "../components/Enrollment/BillingInformation";
import Confirmation from "../components/Confirmation";
import Receipt from "../components/Receipt";
import ContinueEnrollment from "../views/Continue";
import DirectContinue from "../views/DirectContinue";
import External from "../views/External";
import MemberHome from '../views/MemberHome.vue';
import MemberBenefitStore from "../views/MemberBenefitStore";
import PlanQuestionView from "../views/PlanQuestionView";
import BenAdvanceHome from "../views/BenAdvanceHome";
import ErrorPage from "../components/404";
import Referrals from "../components/Referrals";
import GroupOpenHome from "../views/GroupOpenHome";
// import LandingConfigError from "../components/LandingConfigError";
import axios from 'axios';
// import RecommendList from "../views/RecommendList";
import AccessPage from "@/views/AccessPage";
import store from '../store'
import {checkRouteName} from "../utils/CheckRouteUrl"
// new landing page
import LandingPage from "../components/new_home/LandingPage"
import NewPlans from "../components/new_home/NewPlans"
import Api from "../includes/Api";
Vue.use(VueRouter)

const ifRepNotAuthenticated = (to, from, next) => {
  if (!store.getters.isRepAuthenticated) {
    let landingParams = window.location.pathname.slice(1)
    !landingParams && (landingParams = 'mybenefitsdepots')
    let directLink = checkRouteName(window.location.href)
    if (landingParams == 'smarter') {
      localStorage.clear();
      store.dispatch('isRepAuthenticated', true)
      router.push('/smarter')
    } else if (landingParams == 'continue-enrollment') {
      store.dispatch('isRepAuthenticated', true)
      router.push('/continue-enrollment')
    } else if ( directLink.urlPath === 'direct-continue') {
      store.dispatch('isRepAuthenticated', true)
      router.push(`/direct-continue/${directLink.id}/${directLink.tab}`)
    } else if ( directLink.urlPath === 'save-cart-direct-continue') {
      store.dispatch('isRepAuthenticated', true)
      router.push(`/save-cart-direct-continue/${directLink.id}/${directLink.tab}`)
    } else {
      store.dispatch('landingUrl', landingParams)
      store.dispatch('isHomePageRedirect', false)
    }
    return next();
  } else {
    return next()
  }
}

const ifRepAuthenticated = (to, from, next) => {
  if (store.getters.isRepAuthenticated) {
    axios.defaults.headers.common['Authorization'] = 'Basic ' + process.env.VUE_APP_CLIENT_API_TOKEN;
    axios.defaults.headers.common['is-over-65'] = store.getters.isOver65;
    return next();
  } else {
    return next ({ name: 'AccessPage'});
  }
}

const routes = [
  {
    path: '/:landing',
    name: 'AccessPage',
    component: AccessPage,
    beforeEnter: ifRepNotAuthenticated,
    props: true,
    meta: {requiresAuth: false}
  },
  {
    path: '/:landing?',
    name: 'main',
    component: Index,
    beforeEnter: ifRepAuthenticated,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/home',
        name: 'home',
        component: Home
      },
      {
        path: '/agent-home',
        name: 'agent home',
        component: AgentHome
      },
      {
        path: '/continue-enrollment',
        name: 'continue-enrollment',
        component: ContinueEnrollment
      },
      {
        path: '/:landing',
        name: 'LandingPage',
        component: LandingPage
      },
      {
        path: '/website',
        name: 'websites',
        component: GroupOpenHome
      },
      {
        path: '/agent-select-member',
        name: 'agent Member',
        component: AgentSelectMember
      },
      {
        path: '/cart',
        name: 'cart',
        component: Cart
      },
      {
        path: '/plans',
        name: 'plans',
        component: Plans
      },
      {
        path: '/plan/:id/:planName',
        name: 'plan',
        component: Plan
      },
      {
        path: '/PlanQuestionView',
        name: 'PlanQuestionView',
        component: PlanQuestionView
      },
      {
        path: '/confirmation/',
        name: 'Confirmation',
        component: Confirmation
      },
      {
        path: 'enrollment/receipt/',
        name: 'Receipt',
        component: Receipt
      },
      {
        path: '/group-home',
        name: 'group home',
        component: GroupHome
      },
      {
        path: '/group-select-member',
        name: 'group Member',
        component: GroupSelectMember
      },
      {
        path: '/enrollment',
        name: 'enrolment',
        children: [
          {
            path: '/enrollment/personal-info',
            name: 'personal-information',
            component: PersonalInformation
          },
          {
            path: '/enrollment/contact-info',
            name: 'contact-information',
            component: ContactInformation
          },
          {
            path: '/enrollment/employer-info',
            name: 'employer-information',
            component: EmployerInformation
          },
          {
            path: '/enrollment/beneficiary-info',
            name: 'beneficiary-information',
            component: BeneficiaryInformation
          },
          {
            path: '/enrollment/health-questions',
            name: 'health-questions',
            component: HealthQuestions
          },
          {
            path: '/enrollment/dependent-information',
            name: 'dependent-information',
            component: DependentInformation
          },
          {
            path: '/enrollment/review-confirm',
            name: 'review-confirm',
            component: ReviewAndConfirm
          },
          {
            path: '/enrollment/agreement-signature',
            name: 'agreement-signature',
            component: AgreementAndSignature
          },
          {
            path: '/enrollment/billing-information',
            name: 'billing-information',
            component: BillingInformation
          }
        ],
        component: Enrolment
      },
      {
        path: '/save-cart-direct-continue/:id/:tab',
        name: 'save-cart-direct-continue',
        component: DirectContinue
      },
      {
        path: '/direct-continue/:id/:tab',
        name: 'direct-continue',
        component: DirectContinue
      },
      {
        path: '/member-home',
        name: 'member home',
        component: MemberHome
      },
      {
        path: '/member-benefit-store/:id/:tier',
        name: 'member-benefit-store',
        component: MemberBenefitStore
      },
      {
        path: '/BenAdvanceHome',
        name: 'BenAdvanceHome',
        component: BenAdvanceHome
      },
      {
        path: '/referrals',
        name: 'referrals',
        component: Referrals
      },
      {
        path: '/external',
        name: 'external',
        component: External
      },
      {
        path: '/404',
        name: 'error',
        component: ErrorPage
      },
      {
        path: '/:landingUrl/cart',
        name: 'cart',
        component: Cart
      },
      {
        path: '/:landingUrl/plans',
        name: 'plans',
        component: Plans
      },
      {
        path: '/:landingUrl/plan/:id/:planName',
        name: 'plan',
        component: Plan
      },
      {
        path: '/:landingUrl/enrollment/receipt/',
        name: 'Receipt',
        component: Receipt
      },
      {
        path: '/:landingUrl/new-landing',
        name: 'LandingPage',
        component: LandingPage
      },
      {
        path: '/:landingUrl/new-plans',
        name: 'NewPlans',
        component: NewPlans
      },
      {
        path: '/:landingUrl/enrollment',
        name: 'enrolment',
        children: [
          {
            path: '/:landingUrl/enrollment/personal-info',
            name: 'personal-information',
            component: PersonalInformation
          },
          {
            path: '/:landingUrl/enrollment/contact-info',
            name: 'contact-information',
            component: ContactInformation
          },
          {
            path: '/:landingUrl/enrollment/employer-info',
            name: 'employer-information',
            component: EmployerInformation
          },
          {
            path: '/:landingUrl/enrollment/beneficiary-info',
            name: 'beneficiary-information',
            component: BeneficiaryInformation
          },
          {
            path: '/:landingUrl/enrollment/health-questions',
            name: 'health-questions',
            component: HealthQuestions
          },
          {
            path: '/:landingUrl/enrollment/dependent-information',
            name: 'dependent-information',
            component: DependentInformation
          },
          {
            path: '/:landingUrl/enrollment/review-confirm',
            name: 'review-confirm',
            component: ReviewAndConfirm
          },
          {
            path: '/:landingUrl/enrollment/agreement-signature',
            name: 'agreement-signature',
            component: AgreementAndSignature
          },
          {
            path: '/:landingUrl/enrollment/billing-information',
            name: 'billing-information',
            component: BillingInformation
          }
        ],
        component: Enrolment
       },
   /*   {
        path: '/recommend-list',
        name: 'RecommendList',
        component: RecommendList
      },*/
      // new home route
      {
        path: '/new-landing',
        name: 'LandingPage',
        component: LandingPage
      },
      {
        path: '/new-plans',
        name: 'NewPlans',
        component: NewPlans
      }
    ],
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  axios.defaults.headers.common['Authorization'] = 'Basic ' + process.env.VUE_APP_CLIENT_API_TOKEN;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = store.getters.isRepAuthenticated;

  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'AccessPage' });
  } else if (!requiresAuth && isAuthenticated) {
    let url = new URL(window.location.href);
    let landingUrl = url.pathname.split('/')[1]
    let innerLandingUrl = window.location.pathname.slice(1)
    let directLink = checkRouteName(window.location.href)
    let isAccessPageRedirect = store.getters.isHomePageRedirect;
    let storelandingUrl = store.getters.getLandingUrl;

    if (landingUrl === 'cart') {
    return next({name: 'cart'});
    } else if (landingUrl === 'plans') {
      return next({ name: 'plans'});
    } else if (landingUrl === 'new-plans') {
      return next({ name: 'NewPlans'});
    } else if (landingUrl === 'new-landing') {
      return next({name: 'LandingPage'});
    } else  if (landingUrl == 'continue-enrollment') {
      store.dispatch('isRepAuthenticated', true)
      return next({ name: 'continue-enrollment'});
    } else if ( landingUrl === 'save-cart-direct-continue') {
      store.dispatch('isRepAuthenticated', true)
      return next({
        name: 'direct',
        params: {
          id: directLink.id,
          tab: directLink.tab
        }
      });
    } else if ( landingUrl === 'direct-continue') {
      store.dispatch('isRepAuthenticated', true)
      return next({
        name: 'direct',
        params: {
          id: directLink.id,
          tab: directLink.tab
        }
      });
    } else if ( landingUrl === 'group-census-direct-continue') {
      store.dispatch('isRepAuthenticated', true)
      return next({
        name: 'direct',
        params: {
          id: directLink.id,
          tab: directLink.tab
        }
      });
    } else if ( landingUrl === 'pqs-direct-continue') {
      store.dispatch('isRepAuthenticated', true)
      return next({
        name: 'direct',
        params: {
          id: directLink.id,
          tab: directLink.tab
        }
      });
    } else if ( landingUrl === 'decline-reminder-email') {
      store.dispatch('isRepAuthenticated', true)
      return next({ name: 'decline-reminder-email' });
    } else if (isAccessPageRedirect && innerLandingUrl  && (landingUrl !== storelandingUrl)) {
      store.dispatch('innerLandingUrl', innerLandingUrl)
      Api.get('/validate-landing-page?landing_page=' + innerLandingUrl).then(function (response) {
        if (response.data.status == 'success') {
          store.dispatch("isRepAuthenticated", false);
          store.dispatch("landingInfo", null);
          store.dispatch('landingUrl', innerLandingUrl)
          store.dispatch("repInfo", null);
          store.dispatch("groupInfo", null);
          store.dispatch('MUTATION_SET_ERROR', false)
          store.dispatch("zipCode", null);
          store.dispatch('isHomePageRedirect', false)
          store.dispatch('repCode', '')
          store.dispatch('innerLandingUrl', '')
          return next({ name: 'AccessPage',  landing: `${innerLandingUrl}`});
        }
      }).catch(() => {
        store.dispatch('MUTATION_SET_ERROR', true);
      });
    } else {
      return next({ name: 'main', landing: `${store.getters.getLandingUrl}` });
    }
  }
  next();
});

export default router
